import React from 'react';
import { cssVisuallyHidden, Envelope } from '@miro-site/core';
import styled from 'styled-components';
import TopNavigation from './TopNavigation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Label = styled.span.withConfig({
  displayName: "ContactSalesLink__Label",
  componentId: "sc-3fl9ye-0"
})([""]);
var Icon = styled(Envelope).withConfig({
  displayName: "ContactSalesLink__Icon",
  componentId: "sc-3fl9ye-1"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.normalizeStyles({
    width: theme.header.topNavigation.contactSales.icon.width,
    height: theme.header.topNavigation.contactSales.icon.height,
    color: 'inherit'
  });
});
var Link = styled(TopNavigation.Link).withConfig({
  displayName: "ContactSalesLink__Link",
  componentId: "sc-3fl9ye-2"
})(["", "{", "}", "{display:none;", "}"], Label, function (props) {
  return props.theme.mq.v2Desktop(cssVisuallyHidden);
}, Icon, function (props) {
  return props.theme.mq.v2Desktop({
    display: 'block'
  });
});

var ContactSalesLink = function ContactSalesLink(props) {
  return /*#__PURE__*/_jsxs(Link, {
    href: props.href,
    $appearance: props.appearance,
    children: [/*#__PURE__*/_jsx(Label, {
      children: props.label
    }), /*#__PURE__*/_jsx(Icon, {})]
  });
};

export default Object.assign(ContactSalesLink, {
  Label: Label,
  Icon: Icon
});